import { useState } from 'react';
import { PAGINATION } from '../config/pagination';

export const usePagination = () => {
  const [pagination, setPagination] = useState({ 
    page: PAGINATION.DEFAULT_PAGE, 
    limit: PAGINATION.DEFAULT_LIMIT, 
    total: 0, 
    totalPages: 0 
  });

  const handlePageChange = (newPage) => {
    setPagination(prev => ({ ...prev, page: newPage }));
  };

  const updatePagination = (paginationData) => {
    if (paginationData) {
      setPagination(paginationData);
    }
  };

  return {
    pagination,
    handlePageChange,
    updatePagination
  };
};
